export const 서비스_가격목록_쿼리키 = {
  all: ['서비스_가격목록_쿼리키'] as const,
};
